import React from "react";
import styled from "styled-components";
import VoiceControlsPanel from "./VoiceControlsPanel";
import TranslationFeedPanel, { SpeakTurnControl, useSpeakTurnQueue } from "./TranslationFeedPanel";
import { SEQUENCIAL_TRANSLATION } from "../../Constants/constantValues";

const SpeakingTranslator = ({
  messages,
  speechRecongnitionMessages,
  speakStatus,
  setSpeakStatus,
  handleSendCancelSpeakMessage,
  handleRequestSpeakMessage,
  speakersQueue,
  muteMicrophone,
  unmuteMicrophone,
  micEnabledRef,
  translationType,
  setEmotiiVoice,
  emotiiVoice,
  useRealtimeApi = false,
  realtimeTranslations,
  canRequestSpeak = true,
  requestSpeakPayload,
  onIncomingVolumeChange,
  onEmotiiVolumeChange,
  activeCallRef,
  isConference = false,
  isConferenceAttendee = false,
  conferenceTtsPlaybackRate,
  onConferenceTtsSpeedChange,
  incomingVolume,
  dimEnabled,
  emotiiVolume,
  isLeavingCallRef,
  isOverlay = false,
  room = null,
  localParticipant = null,
}) => {
  const hasBottomButton = translationType === SEQUENCIAL_TRANSLATION && canRequestSpeak;

  const {
    ahedUsers,
    handleRequestSpeak,
    handleStopSpeaking,
    handleStopSpeakingWithoutSend,
  } = useSpeakTurnQueue({
    speakersQueue,
    canRequestSpeak,
    translationType,
    speakStatus,
    setSpeakStatus,
    handleSendCancelSpeakMessage,
    handleRequestSpeakMessage,
    requestSpeakPayload,
    muteMicrophone,
    unmuteMicrophone,
    micEnabledRef,
    isLeavingCallRef,
    room,
    localParticipant,
  });

  return (
    <Container hasBottomButton={hasBottomButton}>
      <ListWrapper $overlay={isOverlay}>
        <VoiceControlsPanel
          incomingVolume={incomingVolume}
          dimEnabled={dimEnabled}
          emotiiVolume={emotiiVolume}
          onIncomingVolumeChange={onIncomingVolumeChange}
          onEmotiiVolumeChange={onEmotiiVolumeChange}
          setEmotiiVoice={setEmotiiVoice}
          emotiiVoice={emotiiVoice}
          isConference={isConference}
          isConferenceAttendee={isConferenceAttendee}
          conferenceTtsPlaybackRate={conferenceTtsPlaybackRate}
          onConferenceTtsSpeedChange={onConferenceTtsSpeedChange}
          activeCallRef={activeCallRef}
        />
        <TranslationFeedPanel
          messages={messages}
          speechRecongnitionMessages={speechRecongnitionMessages}
          useRealtimeApi={useRealtimeApi}
          realtimeTranslations={realtimeTranslations}
          isOverlay={isOverlay}
        />
      </ListWrapper>
      <SpeakTurnControl
        translationType={translationType}
        canRequestSpeak={canRequestSpeak}
        speakStatus={speakStatus}
        ahedUsers={ahedUsers}
        handleRequestSpeak={handleRequestSpeak}
        handleStopSpeakingWithoutSend={handleStopSpeakingWithoutSend}
        handleStopSpeaking={handleStopSpeaking}
      />
    </Container>
  );
};

export default SpeakingTranslator;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 450px;
  padding: 10px 20px 0px 0px;
  overflow: hidden;
  padding-bottom: ${({ hasBottomButton }) => hasBottomButton ? '0' : '80px'};
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${({ theme, $overlay }) => $overlay ? "transparent" : theme.callComponent.participantsListBackground};
  overflow: hidden;
  border-radius: 15px 15px 0px 0px;
`;
